// © ООО «Эдиспа», 2022

import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

import Message from 'components/message/Message';
import { PowerGrid } from 'grid';
import ExportPowerGridModal from 'grid/components/ExportPowerGridModal';
import { usePowerGridDispatch } from 'grid/context';
import { actions } from 'grid/store';

const ExportPowerGridFeature: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = usePowerGridDispatch();

  const onComplete = (grid: PowerGrid) => {
    dispatch(actions.setActiveFeature());
    navigate(`/grids/${grid.id}`);
    setTimeout(() => {
      message.info({
        content: (
          <Message type="info">
            Созданная конфигурация открыта для редактирования.
          </Message>
        )
      });
    }, 100);
  };

  const onCancel = () => dispatch(actions.setActiveFeature());

  return (
    <ExportPowerGridModal
      onComplete={onComplete}
      onCancel={onCancel}
      visible={true}
    />
  );
};

export default ExportPowerGridFeature;
